import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactOverlaysModal from 'react-overlays/lib/Modal';
import './stylesheets/Modal.scss';

export default function Modal(props) {
  const { show, children, onHide, className = '' } = props;
  return (
    <ReactOverlaysModal
      backdropClassName={classNames('loc loc-modal-backdrop', className)}
      onHide={onHide}
      show={show}
    >
      <div className={classNames('loc loc-reset loc-modal', className)}>
        { children }
      </div>
    </ReactOverlaysModal>
  );
}

Modal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string
};



// WEBPACK FOOTER //
// ./node_modules/@localytics/loc-components/lib/Modal.jsx